export default __webpack_public_path__ + "static/media/down-arrow-white-quickship-page.64065dcb.svg";